import React from 'react';
import PropTypes from 'prop-types';
import { Container } from '../../components/Layout';
import StaffCard from '../../components/Card/Staff';

const SliceProfile = ({ input }) => {
  //const { id, uid, data } = input.primary.staff.document;
  const profile = input.primary.staff.document.data;

  return (
    <Container restrict center padding={[4, 0, 4, 0]}>
      <StaffCard
        {...profile}
        //key={id.toString()}
      />
    </Container>
  );
};

export default SliceProfile;

SliceProfile.propTypes = {
  input: PropTypes.object.isRequired,
};
